import { useEffect } from "react";
import type * as React from "react";
import { Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { trackWorkflowPageReached } from "analytics";
import StandaloneConfirmationPageLayout from "components/v3/layouts/StandaloneConfirmationPageLayout";
import {
  COLOGUARD_WEBSITE_URL,
  NAVIGATION_EMAIL,
  NAVIGATION_PHONE_DISPLAY
} from "components/v3/pages/CologuardLaunchPage/constants";
import { PATHS } from "constants/pathConstants";
import Translate from "translate/Translate";

const CologuardRedirectLandingPage: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    trackWorkflowPageReached({
      workflow: "colon_cancer_screening",
      page: "redirect_landing",
      workflowStep: "started"
    });
  }, []);

  return (
    <StandaloneConfirmationPageLayout
      backLabel="Back"
      onBack={() => history.push(PATHS.COLOGUARD_LAUNCH_PAGE)}
      onPrimary={() => history.push(PATHS.LANDING_PAGE)}
      pageTitle="Cologuard"
      primaryLabel="Back to my dashboard"
      title="You've been redirected to the Cologuard website"
    >
      <Typography component="p" sx={{ m: 0 }} variant="body_strong_black">
        <Translate text="You should now see the Cologuard website open in a new browser tab. That's where you can confirm your eligibility and request your test." />
      </Typography>
      <Typography component="p" sx={{ m: 0 }} variant="body_black">
        <Translate text="Don't see the new tab?" />{" "}
        <Typography
          component="a"
          href={COLOGUARD_WEBSITE_URL}
          rel="noopener noreferrer"
          sx={{ color: "inherit", fontStyle: "normal", textDecoration: "underline" }}
          target="_blank"
          variant="body_black"
        >
          <Translate text="Click here to continue." />
        </Typography>
      </Typography>
      <Typography
        component="p"
        sx={{ fontStyle: "italic", m: 0 }}
        variant="body_black"
      >
        <Translate text="If you have questions, leave us a message at" />{" "}
        {NAVIGATION_PHONE_DISPLAY} <Translate text="or email" />{" "}
        {NAVIGATION_EMAIL}.
      </Typography>
    </StandaloneConfirmationPageLayout>
  );
};

export default CologuardRedirectLandingPage;
